var $07026cbd7a105f79$exports = {};
$07026cbd7a105f79$exports = {
    "(optional)": `(\u{43D}\u{435}\u{43E}\u{431}\u{43E}\u{432}\u{2019}\u{44F}\u{437}\u{43A}\u{43E}\u{432}\u{43E})`,
    "(required)": `(\u{43E}\u{431}\u{43E}\u{432}\u{2019}\u{44F}\u{437}\u{43A}\u{43E}\u{432}\u{43E})`
};


export {$07026cbd7a105f79$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
